/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Security_Passkey_Delete_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not remove the passkey." |
*
* @param {Partner_Security_Passkey_Delete_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_security_passkey_delete_error = /** @type {((inputs?: Partner_Security_Passkey_Delete_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Security_Passkey_Delete_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Passkey konnte nicht entfernt werden.")
	return /** @type {LocalizedString} */ ("Could not remove the passkey.")
});